import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setShowList } from '../redux/modules/showList/slice';
import { usePermissions } from '../hooks/usePermissions';

// Shared list/form chrome for CRUD pages. Pass `module` (or `cap`) so the "Add"
// button is greyed out for read-only users, and `readOnly` is propagated to the
// List/Form so they can disable their own edit/delete/save controls.
const ListFormHoc = ({ List, Form, showBtn = true, module, cap }) => {
  const dispatch = useDispatch();
  const { currentBranch } = useSelector(state => state.branch)
  const { showList } = useSelector(state => state.reduxShowList)
  const { canWrite, can } = usePermissions();
  const readOnly = cap ? !can(cap) : module ? !canWrite(module) : false;
  const [itemData, setItemData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const toggleList = () => { dispatch(setShowList(!showList))};
  useEffect(() => {
    if (currentBranch) {
      dispatch(setShowList(true));
    }
  }, [dispatch,currentBranch])
  return (
    <>
      {showBtn &&
        <Box textAlign={'right'} mb={3} mt={4}>
          {readOnly ? (
            <Tooltip title="You have read-only access">
              <span style={{ display: 'inline-flex', cursor: 'not-allowed' }}>
                <Button className='commonBtn' variant="contained" disabled startIcon={<AddIcon />}>Add</Button>
              </span>
            </Tooltip>
          ) : (
            <Button className='commonBtn' variant="contained" onClick={() => { toggleList(); setItemData({}) }} startIcon={showList ? <AddIcon /> : <CloseIcon />}> {showList ? "Add" : "Cancel"} </Button>
          )}
        </Box>
      }
      {showList
        ? <List setItemData={setItemData} toggleList={toggleList} itemData={itemData} setCurrentPage={setCurrentPage} currentPage={currentPage} readOnly={readOnly} />
        : <Form itemData={itemData} setItemData={setItemData} toggleList={toggleList} readOnly={readOnly} />}
    </>
  )
}

export default ListFormHoc;
